import { useContext } from "react";
import { useParams } from "react-router-dom";
import { DashboardContext } from "../../../contexts/Dashboard/DashboardContext";
import "./styles.css";

const RemoveButton = (layout: { layout: string }) => {
  const { mode } = useParams();
  const { removeComponent } = useContext(DashboardContext);

  const stopDragGesture = (e: { stopPropagation: () => void }) => {
    e.stopPropagation();
  };

  return mode === "edit" ? (
    <button
      className="button-remove-component"
      type="button"
      onMouseDown={stopDragGesture}
      onTouchStart={stopDragGesture}
      onClick={(e) => {
        e.stopPropagation();
        e.preventDefault();
        removeComponent({ id: layout.layout });
      }}
    >
      X
    </button>
  ) : null;
};

export default RemoveButton;
